(() => {
  'use strict';
  const configElement = document.getElementById('ThemeConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const status = message => { const node = $('#SiteStatus'); if (node) node.textContent = message; };
  const report = (node, message) => { if (node) { node.hidden = !message; node.textContent = message || ''; } };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cookie-preferences]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    try {
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => location.assign(link.href));
    } catch { location.assign(link.href); }
  });
  let dialogTrigger;
  function openDialog(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    $$('dialog[open]').forEach(other => other.close());
    dialogTrigger = trigger || document.activeElement;
    dialog.showModal();
    $('[data-open-menu]')?.setAttribute('aria-expanded', String(dialog.id === 'MobileMenu'));
    return true;
  }
  document.addEventListener('close', event => {
    if (event.target.matches('dialog')) {
      $('[data-open-menu]')?.setAttribute('aria-expanded', 'false');
      if (dialogTrigger?.isConnected) dialogTrigger.focus({ preventScroll: true });
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const dialog = $('dialog[open]');
    if (!dialog) return;
    const focusable = $$('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', dialog).filter(node => node.getClientRects().length && !node.closest('[hidden]'));
    const first = focusable[0], last = focusable.at(-1);
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const menu = event.target.closest('[data-open-menu]');
    if (menu) openDialog($('#MobileMenu'), menu);
    const bag = event.target.closest('[data-open-cart]');
    if (bag && document.body.dataset.cartDrawer === 'true' && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      if (openDialog($('#CartDrawer'), bag)) event.preventDefault();
    }
    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      const input = $('input', step.closest('.quantity-control'));
      if (Number(step.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  class CartController {
    constructor() { this.busy = false; }
    setBusy(value) {
      this.busy = value;
      $$('[data-cart-fragment], [data-product-form]').forEach(node => node.setAttribute('aria-busy', String(value)));
      $$('[data-cart-fragment] button, [data-cart-fragment] input, [data-product-form] button[type="submit"]').forEach(control => {
        if (value) { control.dataset.wasDisabled = String(control.disabled); control.disabled = true; }
        else if ('wasDisabled' in control.dataset) { control.disabled = control.dataset.wasDisabled === 'true'; delete control.dataset.wasDisabled; }
      });
    }
    sections() { return [...new Set($$('[data-cart-section]').map(node => node.dataset.cartSection))].slice(0, 5); }
    async refresh(sections, expectedIds) {
      const missing = expectedIds.some(id => !sections?.[id]);
      if (missing) {
        const url = new URL(config.routes.cart, location.origin);
        url.searchParams.set('sections', expectedIds.join(','));
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(config.strings.retry);
        sections = await response.json();
      }
      const savedNote = $('[data-cart-note]')?.value;
      const savedNoteOpen = $('.cart-note')?.open;
      const active = document.activeElement;
      const focusId = active?.id;
      const key = active?.closest('[data-line-key]')?.dataset.lineKey;
      const focusKind = active?.hasAttribute('data-cart-quantity') ? '[data-cart-quantity]' : active?.hasAttribute('data-cart-step') ? `[data-cart-step="${active.dataset.cartStep}"]` : null;
      const replacements = [];
      for (const current of $$('[data-cart-section]')) {
        const html = sections[current.dataset.cartSection];
        if (!html) throw new Error(config.strings.retry);
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById(current.id);
        if (!fresh) throw new Error(config.strings.retry);
        replacements.push([current, fresh]);
      }
      replacements.forEach(([current, fresh]) => current.replaceWith(fresh));
      if (savedNote !== undefined && $('[data-cart-note]')) $('[data-cart-note]').value = savedNote;
      if (savedNoteOpen !== undefined && $('.cart-note')) $('.cart-note').open = savedNoteOpen;
      const count = $('[data-cart-total]')?.dataset.cartTotal || '0';
      $$('[data-cart-count]').forEach(node => { node.textContent = count; });
      let focusTarget;
      if (key && focusKind) {
        const container = replacements.find(([old]) => old.contains(active))?.[1];
        focusTarget = $$('[data-line-key]', container || document).find(line => line.dataset.lineKey === key)?.querySelector(focusKind);
      } else if (focusId) focusTarget = document.getElementById(focusId);
      if (focusTarget) focusTarget.focus({ preventScroll: true });
      else if (active && !active.isConnected && $('#CartDrawer')?.open) $('[data-close-dialog]', $('#CartDrawer')).focus();
    }
    async mutate(route, payload, errorNode, { added = false, trigger = null } = {}) {
      if (this.busy) return;
      this.setBusy(true);
      report(errorNode, '');
      const sectionIds = this.sections();
      const params = { sections: sectionIds, sections_url: config.routes.cart };
      let body, headers = { Accept: 'application/json' };
      if (payload instanceof FormData) {
        payload.set('sections', sectionIds.join(','));
        payload.set('sections_url', config.routes.cart);
        body = payload;
      } else { body = JSON.stringify({ ...payload, ...params }); headers['Content-Type'] = 'application/json'; }
      let committed = false;
      try {
        const response = await fetch(route, { method: 'POST', headers, body });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : config.strings.error);
        committed = true;
        await this.refresh(result.sections, sectionIds);
        status(added ? config.strings.added : config.strings.updated);
        if (added) {
          if (document.body.dataset.cartDrawer !== 'true' || !openDialog($('#CartDrawer'), trigger)) location.assign(config.routes.cart);
        }
      } catch (error) {
        if (committed) { status(config.strings.retry); location.assign(config.routes.cart); }
        else {
          try { await this.refresh(null, sectionIds); }
          catch { $$('[data-cart-quantity]').forEach(input => { input.value = input.defaultValue; }); }
          report(errorNode?.isConnected ? errorNode : $('[data-cart-error]'), error.message || config.strings.error);
        }
      } finally { this.setBusy(false); }
    }
  }
  const cart = new CartController();
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch || !window.FormData) return;
    event.preventDefault();
    if (cart.busy || !form.reportValidity()) return;
    const payload = new FormData(form);
    if (!payload.get('id')) return;
    cart.mutate(config.routes.add, payload, $('[data-form-error]', form), { added: true, trigger: event.submitter || $('button[type="submit"]', form) });
  });
  function cartError(origin) { return $('[data-cart-error]', origin.closest('dialog') || origin.closest('[data-cart-page]') || document); }
  document.addEventListener('click', event => {
    const step = event.target.closest('[data-cart-step]');
    const remove = event.target.closest('[data-cart-remove]');
    if (!step && !remove) return;
    event.preventDefault();
    if (cart.busy) return;
    const row = (step || remove).closest('[data-line-key]');
    const input = $('[data-cart-quantity]', row);
    if (step) {
      if (Number(step.dataset.cartStep) > 0) input.stepUp(); else input.stepDown();
      if (!input.checkValidity()) return;
    }
    const update = { id: row.dataset.lineKey, quantity: remove ? 0 : Number(input.value) };
    cart.mutate(config.routes.change, update, cartError(step || remove));
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-quantity]');
    if (input) {
      if (cart.busy) return;
      if (!input.checkValidity()) { input.reportValidity(); input.value = input.defaultValue; return; }
      const payload = { id: input.dataset.key, quantity: Number(input.value) };
      cart.mutate(config.routes.change, payload, cartError(input));
    }
    if (event.target.matches('[data-sort]')) event.target.form.requestSubmit();
  });
  const variantRequests = new Map();
  document.addEventListener('change', async event => {
    const option = event.target.closest('[data-option-value-id]');
    if (!option) return;
    const section = option.closest('[data-product-section]');
    const sectionId = section.dataset.sectionId;
    variantRequests.get(sectionId)?.abort();
    const controller = new AbortController();
    variantRequests.set(sectionId, controller);
    const quantity = $('[name="quantity"]', section)?.value;
    const selected = $$('[data-option-value-id]:checked', section).map(input => input.dataset.optionValueId);
    const url = new URL(option.dataset.productUrl || section.dataset.productUrl, location.origin);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('option_values', selected.join(','));
    section.setAttribute('aria-busy', 'true');
    const button = $('button[type="submit"]', section);
    if (button) button.disabled = true;
    const variantInput = $('[name="id"]', section);
    if (variantInput) variantInput.disabled = true;
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(config.strings.variantError);
      const html = await response.text();
      if (controller.signal.aborted) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-product-section]', doc);
      if (!fresh) throw new Error(config.strings.variantError);
      const qty = $('[name="quantity"]', fresh);
      if (qty && quantity) { qty.value = quantity; if (!qty.checkValidity()) qty.value = qty.defaultValue; }
      section.replaceWith(fresh);
      const selectedVariant = fresh.dataset.selectedVariant;
      const browserUrl = new URL(fresh.dataset.productUrl, location.origin);
      if (selectedVariant) browserUrl.searchParams.set('variant', selectedVariant);
      else browserUrl.searchParams.set('option_values', selected.join(','));
      history.replaceState({}, '', browserUrl);
      const focused = $$('[data-option-value-id]', fresh).find(input => input.dataset.optionValueId === option.dataset.optionValueId);
      focused?.focus({ preventScroll: true });
      status($('.product-price', fresh)?.textContent.trim() || '');
      window.Shopify?.PaymentButton?.init();
      initReveal(fresh);
    } catch (error) {
      if (error.name !== 'AbortError') {
        report($('[data-form-error]', section), config.strings.variantError);
        const nativeUrl = new URL(option.dataset.productUrl || section.dataset.productUrl, location.origin);
        nativeUrl.searchParams.set('option_values', selected.join(','));
        const errorNode = $('[data-form-error]', section);
        const link = document.createElement('a');
        link.href = nativeUrl.toString();
        link.textContent = config.strings.variantError;
        if (errorNode) { errorNode.textContent = ''; errorNode.append(link); }
      }
    } finally {
      if (variantRequests.get(sectionId) === controller) { variantRequests.delete(sectionId); section.removeAttribute('aria-busy'); }
    }
  });
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionAllowed = () => document.body.dataset.motion === 'true' && !reducedMotion.matches;
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
  }), { threshold: 0.08 }) : null;
  function initReveal(root = document) {
    if (!motionAllowed() || !revealObserver) return;
    $$('.reveal', root).forEach(node => {
      if (node.getBoundingClientRect().top > window.innerHeight) { node.classList.add('reveal-ready'); revealObserver.observe(node); }
    });
  }
  function initRecommendations(root = document) {
    $$('[data-recommendations]', root).forEach(node => {
      if (node.dataset.loaded) return;
      node.dataset.loaded = 'true';
      const load = async () => {
        try {
          const response = await fetch(node.dataset.url);
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = $('[data-recommendations]', doc);
          if (content?.innerHTML.trim()) { node.innerHTML = content.innerHTML; initReveal(node); }
          else node.hidden = true;
        } catch { node.hidden = true; }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) { observer.disconnect(); load(); } }, { rootMargin: '250px' });
        observer.observe(node);
      } else load();
    });
  }
  let framePending = false;
  function onScroll() {
    if (framePending || !motionAllowed()) return;
    framePending = true;
    requestAnimationFrame(() => {
      const visual = $('[data-parallax]');
      if (visual && window.innerWidth > 900 && window.scrollY < window.innerHeight) visual.style.setProperty('--parallax', `${Math.min(window.scrollY * 0.035, 24)}px`);
      framePending = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) { $$('.reveal-ready').forEach(n => n.classList.add('is-visible')); $$('[data-parallax]').forEach(n => n.style.removeProperty('--parallax')); }
  });
  document.addEventListener('shopify:section:load', event => { initReveal(event.target); initRecommendations(event.target); });
  document.addEventListener('shopify:section:select', event => $$('.reveal-ready', event.target).forEach(node => node.classList.add('is-visible')));
  document.addEventListener('shopify:block:select', event => event.target.classList.add('is-visible'));
  function initAddresses(root = document) {
    $$('[data-address-country]', root).forEach(country => {
      const form = country.closest('form');
      const province = $('[data-address-province]', form);
      const wrapper = $('[data-province-wrapper]', form);
      if (!province || !wrapper) return;
      if (country.dataset.default) country.value = country.dataset.default;
      function update() {
        const provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
        province.replaceChildren(...provinces.map(([value, label]) => new Option(label, value)));
        wrapper.hidden = !provinces.length;
        province.disabled = !provinces.length;
        if (province.dataset.default) province.value = province.dataset.default;
      }
      country.addEventListener('change', update);
      update();
    });
  }
  document.addEventListener('shopify:section:load', event => initAddresses(event.target));
  const countryPickers = new WeakMap();
  const countryKey = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  function initCountryPickers(root = document) {
    $$('[data-country-picker]', root).forEach(picker => {
      if (countryPickers.has(picker)) return;
      const select = $('[data-country-select]', picker);
      const input = $('[data-country-input]', picker);
      const popup = $('[data-country-popup]', picker);
      const list = $('[data-country-options]', picker);
      const empty = $('[data-country-empty]', picker);
      const live = $('[data-country-status]', picker);
      const countries = [...select.options].filter(option => option.value && option.value !== '---' && !option.disabled).map(option => ({ value: option.value, label: option.textContent.trim() }));
      if (!countries.length) return;
      let matches = [], active = -1;
      function close() {
        popup.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        live.textContent = '';
        active = -1;
      }
      function sync() {
        const country = countries.find(item => countryKey(item.label) === countryKey(input.value));
        select.value = country?.value || '';
        input.setCustomValidity(input.value && !country ? picker.dataset.invalid : '');
      }
      function render(query = input.value) {
        matches = countries.filter(country => countryKey(country.label).includes(countryKey(query)));
        active = -1;
        input.removeAttribute('aria-activedescendant');
        list.replaceChildren(...matches.map((country, index) => {
          const option = document.createElement('li');
          option.id = list.id + '-' + index;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          option.tabIndex = -1;
          option.dataset.countryIndex = String(index);
          option.textContent = country.label;
          return option;
        }));
        empty.hidden = matches.length > 0;
        popup.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        live.textContent = picker.dataset.results.replace('[count]', String(matches.length));
      }
      function choose(index) {
        if (!matches[index]) return;
        input.value = matches[index].label;
        sync();
        input.focus({ preventScroll: true });
        close();
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const open = () => render(select.value ? '' : input.value);
      input.addEventListener('focus', open);
      input.addEventListener('click', () => { if (popup.hidden) open(); });
      input.addEventListener('input', () => { sync(); render(); });
      input.addEventListener('change', sync);
      input.addEventListener('blur', sync);
      input.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (popup.hidden) open();
          if (!matches.length) return;
          active = event.key === 'ArrowDown' ? Math.min(active + 1, matches.length - 1) : active < 0 ? matches.length - 1 : Math.max(active - 1, 0);
          [...list.children].forEach((option, index) => option.setAttribute('aria-selected', String(index === active)));
          const option = list.children[active];
          input.setAttribute('aria-activedescendant', option.id);
          option.scrollIntoView?.({ block: 'nearest' });
        } else if (event.key === 'Enter' && !popup.hidden && active >= 0) {
          event.preventDefault();
          choose(active);
        } else if (event.key === 'Escape' && !popup.hidden) {
          event.preventDefault();
          close();
        } else if (event.key === 'Tab') close();
      });
      list.addEventListener('mousedown', event => event.preventDefault());
      list.addEventListener('click', event => {
        const option = event.target.closest('[data-country-index]');
        if (option) choose(Number(option.dataset.countryIndex));
      });
      select.form.addEventListener('reset', () => setTimeout(() => {
        input.value = countries.find(country => country.value === select.value)?.label || '';
        sync();
        close();
      }, 0));
      if (select.dataset.default) select.value = select.dataset.default;
      input.value = countries.find(country => country.value === select.value)?.label || '';
      select.hidden = true;
      select.required = false;
      input.disabled = false;
      $('[data-country-search]', picker).hidden = false;
      $('label', picker).htmlFor = input.id;
      sync();
      countryPickers.set(picker, { close });
    });
  }
  ['click', 'focusin'].forEach(type => document.addEventListener(type, event => {
    $$('[data-country-picker]').forEach(picker => {
      if (!picker.contains(event.target)) countryPickers.get(picker)?.close();
    });
  }));
  const phonePickers = new WeakMap();
  function initPhonePickers(root = document) {
    $$('[data-phone-picker]', root).forEach(picker => {
      if (phonePickers.has(picker)) return;
      const select = $('[data-phone-select]', picker);
      const trigger = $('[data-phone-trigger]', picker);
      const popup = $('[data-phone-popup]', picker);
      const search = $('[data-phone-search]', picker);
      const list = $('[data-phone-options]', picker);
      const live = $('[data-phone-status]', picker);
      const phone = $('input[type=tel]', picker);
      const aliases = { GB: 'uk great britain', US: 'usa america', AE: 'uae' };
      const countries = [...select.options].map(option => ({value:option.value, iso:option.dataset.iso, code:option.dataset.code, label:option.dataset.countryName, flag:option.dataset.flagUrl}));
      let matches = [], active = -1;
      function sync() {
        const choice = countries.find(country => country.value === select.value);
        if (!choice) return;
        $('[data-phone-flag]', trigger).src = choice.flag;
        $('[data-phone-code]', trigger).textContent = choice.code;
        trigger.setAttribute('aria-label', `${picker.dataset.codeLabel}: ${choice.label} (${choice.code})`);
      }
      function close(restoreFocus = false) {
        popup.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        search.setAttribute('aria-expanded', 'false');
        search.removeAttribute('aria-activedescendant');
        live.textContent = '';
        active = -1;
        if (restoreFocus) trigger.focus({preventScroll:true});
      }
      function render() {
        const query = countryKey(search.value);
        matches = countries.filter(country => countryKey(`${country.label} ${country.iso} ${country.code} ${aliases[country.iso] || ''}`).includes(query));
        active = -1;
        search.removeAttribute('aria-activedescendant');
        list.replaceChildren(...matches.map((country,index) => {
          const option = document.createElement('li');
          option.id = list.id + '-' + index;
          option.setAttribute('role','option');
          option.setAttribute('aria-selected',String(country.value === select.value));
          option.dataset.phoneIndex = String(index);
          const flag = document.createElement('img');
          flag.src = country.flag; flag.alt = ''; flag.width = 24; flag.height = 16; flag.loading = 'lazy';
          const name = document.createElement('span'); name.textContent = country.label;
          const code = document.createElement('small'); code.textContent = country.code;
          option.append(flag,name,code);
          return option;
        }));
        $('[data-phone-empty]', picker).hidden = matches.length > 0;
        live.textContent = picker.dataset.results.replace('[count]',String(matches.length));
      }
      function open() {
        search.value = '';
        popup.hidden = false;
        trigger.setAttribute('aria-expanded','true');
        search.setAttribute('aria-expanded','true');
        render();
        search.focus({preventScroll:true});
      }
      function choose(index) {
        if (!matches[index]) return;
        select.value = matches[index].value;
        select.dispatchEvent(new Event('change',{bubbles:true}));
        close();
        phone.focus({preventScroll:true});
      }
      trigger.addEventListener('click', () => popup.hidden ? open() : close(true));
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); open(); }
      });
      search.addEventListener('input',render);
      search.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!matches.length) return;
          active = event.key === 'ArrowDown' ? Math.min(active + 1,matches.length - 1) : active < 0 ? matches.length - 1 : Math.max(active - 1,0);
          [...list.children].forEach((option,index) => option.dataset.active = String(index === active));
          const option = list.children[active];
          search.setAttribute('aria-activedescendant',option.id);
          option.scrollIntoView?.({block:'nearest'});
        } else if (event.key === 'Enter') {
          event.preventDefault();
          if (active >= 0) choose(active);
          else if (matches.length === 1) choose(0);
        } else if (event.key === 'Tab') {
          event.preventDefault();
          close();
          if (event.shiftKey) trigger.focus({preventScroll:true}); else phone.focus({preventScroll:true});
        }
      });
      picker.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !popup.hidden) { event.preventDefault(); close(true); }
      });
      list.addEventListener('mousedown',event => event.preventDefault());
      list.addEventListener('click', event => {
        const option = event.target.closest('[data-phone-index]');
        if (option) choose(Number(option.dataset.phoneIndex));
      });
      select.addEventListener('change',sync);
      select.form.addEventListener('reset', () => setTimeout(() => { sync(); close(); },0));
      select.hidden = true;
      select.required = false;
      trigger.hidden = false;
      $('[data-phone-control]',picker).dataset.enhanced = '';
      sync();
      phonePickers.set(picker,{close});
    });
  }
  ['click','focusin'].forEach(type => document.addEventListener(type,event => {
    $$('[data-phone-picker]').forEach(picker => {
      if (!picker.contains(event.target)) phonePickers.get(picker)?.close();
    });
  }));
  function initEnquiryForms(root = document) {
    initCountryPickers(root);
    initPhonePickers(root);
    const forms = $$('[data-enquiry-form]', root);
    const target = forms.find(form => '#' + form.id === window.location.hash);
    forms.forEach(form => {
      const result = $('[data-form-result]', form);
      if (!result) return;
      result.hidden = Boolean(target && form !== target);
      if (form === target) {
        const focusResult = () => requestAnimationFrame(() => result.focus({ preventScroll: true }));
        if (document.readyState === 'complete') focusResult();
        else window.addEventListener('load', focusResult, { once: true });
      }
    });
  }
  document.addEventListener('shopify:section:load', event => initEnquiryForms(event.target));
  initEnquiryForms();
  initAddresses();
  initReveal();
  initRecommendations();
})();
(() => {
  const enhanceStoredForms = (scope = document) => {
    scope.querySelectorAll('[data-stored-form]').forEach(wrapper => {
      if (wrapper.dataset.formsReady) return;
      wrapper.dataset.formsReady = 'true';
      const countries = [...(wrapper.querySelector('[data-stored-countries]')?.content.querySelectorAll('option') || [])]
        .map(option => option.textContent.trim()).filter(name => name && name !== '---');
      const attach = () => {
        const root = wrapper.querySelector('shopify-forms-embed')?.shadowRoot;
        if (!root) return false;
        if (root.querySelector('[data-ao-form-style]')) return true;
        const style = document.createElement('style');
        style.dataset.aoFormStyle = '';
        style.textContent = `
          [data-current-step="form"] section[class*="_formHeader_"] { display: none; }
          [data-testid="form"] { gap: 24px !important; }
          input:not([type="checkbox"]):not([type="radio"]), button:has(#country-selector-value) { height: 56px !important; min-height: 56px !important; box-sizing: border-box !important; font-size: 16px !important; }
          textarea:not([name="h-captcha-response"]) { min-height: 150px !important; box-sizing: border-box !important; border-radius: 24px !important; font-size: 16px !important; padding: 16px !important; }
          [data-ao-stacked-label] { display: flex; flex-direction: column; gap: 10px; }
          [data-ao-stacked-label]::before { display: none !important; }
          [data-ao-stacked-label] > label { position: static !important; order: -1; transform: none !important; font-size: 14px !important; white-space: normal !important; max-width: none !important; width: auto !important; line-height: 1.5 !important; padding: 0 !important; background: none !important; color: var(--form-text-color) !important; }
          [data-ao-stacked-label] > input { padding: 16px !important; }
          label[for="phone_number"] { font-size: 13px !important; white-space: nowrap !important; transform: translateY(-8px) !important; }
          .ao-country-options { position: absolute; z-index: 10; top: calc(100% + 6px); left: 0; right: 0; max-height: 220px; overflow-y: auto; border: 1px solid #68616f; border-radius: 16px; background: #131018; color: #f5f3f7; box-shadow: 0 12px 24px #0008; padding: 6px; }
          .ao-country-options[hidden] { display: none; }
          .ao-country-options [role="option"] { padding: 10px 12px; min-height: 44px; box-sizing: border-box; border-radius: 10px; cursor: pointer; font-size: 14px; line-height: 24px; }
          .ao-country-options [role="option"]:hover, .ao-country-options [aria-selected="true"] { background: #30233f; }
          .ao-country-error { margin: 8px 0 0; color: #ffb4b4; font-size: 14px; line-height: 1.5; }
          .ao-country-error[hidden] { display: none; }
          [data-testid="btn-form-submit"] {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            align-self: flex-start !important;
            flex-shrink: 0 !important;
            width: var(--button-width, 220px) !important;
            max-width: 100% !important;
            height: var(--control-height, 56px) !important;
            min-height: var(--control-height, 56px) !important;
            box-sizing: border-box !important;
            margin: 0 !important;
            padding: 16px 24px !important;
            border: 1px solid transparent !important;
            border-radius: 100px !important;
            font-size: var(--button-font, 14px) !important;
            font-weight: 500 !important;
            line-height: 1.2 !important;
            text-align: center !important;
            background: var(--primary, #6d28d9) !important;
            color: #fff !important;
            transition: background .25s, color .25s, border-color .25s !important;
          }
          [data-testid="btn-form-submit"]:is(:hover, :focus-visible):not(:disabled):not([aria-disabled="true"]) { background: var(--highlight, #8b5cf6) !important; color: var(--bg, #08070a) !important; }
          [data-testid="btn-form-submit"]:focus-visible { outline: 2px solid var(--text, #f5f3f7) !important; outline-offset: -5px !important; }
          [class*="_formDisclaimer_"], [class*="_formDisclaimer_"] p { font-size: 13px !important; line-height: 1.6 !important; text-align: left !important; }
          [class*="_formDisclaimer_"] { margin-top: 24px !important; }
          label { line-height: 1.5; }
          [role="dialog"][data-sizing="form-wrapper"] { outline: none; }
          @media (prefers-reduced-motion: reduce) { * { animation: none !important; transition: none !important; } }
        `;
        root.append(style);
        const attachCountries = input => {
          if (input.dataset.aoCountries) return;
          input.dataset.aoCountries = 'true';
          input.required = true;
          input.autocomplete = 'country-name';
          input.spellcheck = false;
          input.setAttribute('role', 'combobox');
          input.setAttribute('aria-autocomplete', 'list');
          input.setAttribute('aria-expanded', 'false');
          const list = document.createElement('div');
          list.id = `ao-country-options-${wrapper.dataset.storedForm}`;
          list.className = 'ao-country-options';
          list.setAttribute('role', 'listbox');
          list.setAttribute('aria-label', 'Countries');
          list.hidden = true;
          input.setAttribute('aria-controls', list.id);
          input.parentElement.append(list);
          const error = document.createElement('p');
          error.id = `${list.id}-error`;
          error.className = 'ao-country-error';
          error.setAttribute('role', 'alert');
          error.textContent = 'Choose a country from the list so we can save its full name.';
          error.hidden = true;
          input.parentElement.after(error);
          input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
          const key = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim().replace(/\s+/g, ' ');
          const aliases = { uk: 'United Kingdom', gb: 'United Kingdom', 'great britain': 'United Kingdom', usa: 'United States', us: 'United States', 'united states of america': 'United States', uae: 'United Arab Emirates' };
          const resolve = value => countries.find(name => key(name) === key(aliases[key(value)] || value));
          let matches = [], selected = -1, committing = false, pointer = null, ignoreClick = false;
          const close = () => { list.hidden = true; selected = -1; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); };
          const write = name => {
            if (input.value === name) return;
            committing = true;
            Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, name);
            input.dispatchEvent(new InputEvent('input', { bubbles: true, composed: true, inputType: 'insertReplacementText', data: name }));
            input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
            committing = false;
          };
          const validate = (showError = false, canonicalise = false) => {
            const country = resolve(input.value);
            if (country && canonicalise) write(country);
            input.setCustomValidity(country ? '' : error.textContent);
            if (country || showError) {
              error.hidden = Boolean(country);
              input.setAttribute('aria-invalid', String(!country));
            }
            return Boolean(country);
          };
          const choose = name => {
            write(name);
            validate();
            input.focus({ preventScroll: true });
            close();
          };
          const show = () => {
            matches = countries.filter(name => key(name).includes(key(aliases[key(input.value)] || input.value)));
            selected = -1;
            input.removeAttribute('aria-activedescendant');
            list.replaceChildren(...matches.map((name, index) => {
              const option = document.createElement('div');
              option.id = `${list.id}-${index}`;
              option.setAttribute('role', 'option');
              option.setAttribute('aria-selected', 'false');
              option.textContent = name;
              option.addEventListener('pointerdown', event => {
                if (event.button !== 0) return;
                ignoreClick = false;
                pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, name, option };
                if (event.pointerType === 'mouse') event.preventDefault();
              });
              option.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();
                if (!ignoreClick) choose(name);
                ignoreClick = false;
              });
              return option;
            }));
            list.hidden = !matches.length;
            input.setAttribute('aria-expanded', String(matches.length > 0));
          };
          root.addEventListener('pointermove', event => {
            if (pointer?.id === event.pointerId && Math.hypot(event.clientX - pointer.x, event.clientY - pointer.y) > 10) pointer.moved = true;
          }, true);
          root.addEventListener('pointerup', event => {
            if (pointer?.id !== event.pointerId) return;
            const picked = pointer;
            pointer = null;
            ignoreClick = true;
            if (!picked.moved && Math.hypot(event.clientX - picked.x, event.clientY - picked.y) <= 10 && picked.option.contains(event.target)) choose(picked.name);
            else if (root.activeElement !== input) { close(); validate(true, true); }
          }, true);
          root.addEventListener('pointercancel', () => {
            pointer = null;
            ignoreClick = true;
            if (root.activeElement !== input) { close(); validate(true, true); }
          }, true);
          input.addEventListener('input', () => {
            if (committing) return;
            error.hidden = true;
            input.removeAttribute('aria-invalid');
            validate();
            show();
          });
          input.addEventListener('change', () => { if (!committing) validate(false, true); });
          input.addEventListener('focus', show);
          input.addEventListener('click', () => { if (list.hidden) show(); });
          input.addEventListener('blur', () => {
            if (pointer) return;
            close();
            validate(Boolean(input.value), true);
          });
          input.addEventListener('invalid', () => validate(true));
          input.addEventListener('keydown', event => {
            if (event.key === 'Escape') { close(); return; }
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
              event.preventDefault();
              if (list.hidden) show();
              if (!matches.length) return;
              selected = (selected + (event.key === 'ArrowDown' ? 1 : -1) + matches.length) % matches.length;
              [...list.children].forEach((option, index) => option.setAttribute('aria-selected', String(index === selected)));
              input.setAttribute('aria-activedescendant', list.children[selected].id);
              list.children[selected].scrollIntoView?.({ block: 'nearest' });
            } else if (event.key === 'Enter' && !event.isComposing && !list.hidden) {
              event.preventDefault();
              if (selected >= 0 || matches.length === 1) choose(matches[Math.max(selected, 0)]);
              else validate(true, true);
            } else if (event.key === 'Tab') {
              close();
              validate(Boolean(input.value), true);
            }
          });
          const guard = event => {
            if (!input.isConnected || validate(true, true)) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            input.focus({ preventScroll: true });
            input.scrollIntoView?.({ block: 'center', behavior: 'instant' });
          };
          input.form.addEventListener('submit', guard, true);
          root.addEventListener('click', event => {
            if (event.target.closest('[data-testid="btn-form-submit"]')) guard(event);
          }, true);
          input.form.addEventListener('reset', () => setTimeout(() => {
            close();
            error.hidden = true;
            input.removeAttribute('aria-invalid');
            validate();
          }, 0));
          validate();
        };
        const enhanceFields = () => {
          const form = root.querySelector('form');
          if (!form) return;
          const group = root.querySelector('[role="dialog"][data-sizing="form-wrapper"]');
          if (group) { group.setAttribute('role', 'group'); group.removeAttribute('aria-modal'); }
          form.querySelectorAll('input, textarea').forEach(input => {
            if (input.name === 'h-captcha-response' || input.type === 'hidden') return;
            if (!input.id && input.name) input.id = input.name;
            const label = [...form.querySelectorAll('label')].find(item => item.htmlFor === input.id);
            if (!label) return;
            if (input.tagName === 'TEXTAREA' || /website/i.test(label.textContent)) input.parentElement.dataset.aoStackedLabel = '';
            if (!input.hasAttribute('aria-labelledby') && label.id) input.setAttribute('aria-labelledby', label.id);
            const optional = /optional/i.test(label.textContent);
            if (!optional && input.type !== 'checkbox' && input.type !== 'radio') {
              input.setAttribute('aria-required', 'true');
              if (!label.querySelector('[data-required-mark]')) {
                const mark = document.createElement('span');
                mark.dataset.requiredMark = '';
                mark.setAttribute('aria-hidden', 'true');
                mark.textContent = ' *';
                label.append(mark);
              }
            }
            if (/^country\b/i.test(label.textContent) && countries.length) {
              attachCountries(input);
            }
          });
          const email = form.querySelector('#email');
          const name = form.querySelector('#first_name');
          if (email) email.autocomplete = 'email';
          if (name) name.autocomplete = 'name';
        };
        new MutationObserver(enhanceFields).observe(root, { childList: true, subtree: true });
        enhanceFields();
        return true;
      };
      if (!attach()) {
        let attempts = 0;
        const timer = setInterval(() => { if (attach() || ++attempts >= 120 || !wrapper.isConnected) clearInterval(timer); }, 250);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceStoredForms(), { once: true });
  else enhanceStoredForms();
  document.addEventListener('shopify:section:load', event => enhanceStoredForms(event.target));
})();
(() => {
  const opportunityAnchors = new Set(['ShareYourDream', 'TheVault', 'AnthonyOneToOne', 'Sponsors']);
  const main = document.querySelector('main');
  if (!main) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionAllowed = () => !reducedMotion.matches && document.body.dataset.motion !== 'false';
  const getTarget = hash => {
    try {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      return target && main.contains(target) ? target : null;
    } catch { return null; }
  };
  let stopFollowing = () => {};
  const followAnchor = ({ smooth = false, focus = false } = {}) => {
    stopFollowing();
    const target = getTarget(location.hash);
    if (!target) return;
    const controller = new AbortController();
    const { signal } = controller;
    let frame = 0;
    let observer;
    let timeout;
    let destination;
    const stop = () => {
      controller.abort();
      observer?.disconnect();
      cancelAnimationFrame(frame);
      clearTimeout(timeout);
    };
    stopFollowing = stop;
    const align = () => {
      frame = 0;
      if (signal.aborted || !target.isConnected) return;
      const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      const padding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      const top = target.getBoundingClientRect().top;
      const nextDestination = top + window.scrollY - margin - padding;
      // Observe layout movement, not the changing viewport position during a smooth scroll.
      if (destination !== undefined && Math.abs(nextDestination - destination) < 2) return;
      destination = nextDestination;
      if (Math.abs(top - margin - padding) > 2) {
        target.scrollIntoView({ block: 'start', behavior: smooth && motionAllowed() ? 'smooth' : 'instant' });
      }
    };
    const queue = () => {
      if (!signal.aborted && !frame) frame = requestAnimationFrame(align);
    };
    const interrupt = () => {
      stop();
      // Give control back immediately, including while a browser scroll animation is running.
      if (smooth) window.scrollTo({ top: window.scrollY, left: window.scrollX, behavior: 'instant' });
    };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => {
      window.addEventListener(type, interrupt, { capture: true, passive: true, signal });
    });
    if (focus) {
      const focusTarget = target.querySelector('h1, h2, h3') || target;
      const temporary = !focusTarget.hasAttribute('tabindex');
      if (temporary) {
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.classList.add('anchor-focus');
        focusTarget.addEventListener('blur', () => {
          focusTarget.removeAttribute('tabindex');
          focusTarget.classList.remove('anchor-focus');
        }, { once: true });
      }
      focusTarget.focus({ preventScroll: true });
    }
    if (opportunityAnchors.has(target.id) && 'ResizeObserver' in window) {
      observer = new ResizeObserver(queue);
      observer.observe(main);
      [...main.children].forEach(section => observer.observe(section));
    }
    window.addEventListener('load', queue, { once: true, signal });
    document.fonts?.ready.then(queue);
    timeout = setTimeout(stop, 15000);
    queue();
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.hasAttribute('data-cookie-preferences') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !getTarget(url.hash)) return;
    event.preventDefault();
    const menu = link.closest('dialog');
    if (menu?.open) menu.close();
    if (url.hash !== location.hash) history.pushState(null, '', url.hash);
    followAnchor({ smooth: !link.classList.contains('skip-link'), focus: true });
  });
  window.addEventListener('hashchange', () => followAnchor());
  window.addEventListener('pagehide', () => stopFollowing());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => followAnchor(), { once: true });
  else followAnchor();
})();

// Progressive enhancement: a brief native crossfade for editorial pages, with no delayed navigation.
(() => {
  const motionAllowed = () => document.body.dataset.motion !== 'false' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isContentPage = url => {
    const path = new URL(url, location.href).pathname;
    return path === '/' || ['pages', 'products', 'collections'].includes(path.split('/')[1]);
  };
  let transition;
  window.addEventListener('pageswap', event => {
    const destination = event.activation?.entry?.url;
    if (!motionAllowed() || !destination || !isContentPage(location.href) || !isContentPage(destination)) event.viewTransition?.skipTransition();
  });
  window.addEventListener('pagereveal', event => {
    transition = event.viewTransition;
    if (!motionAllowed()) transition?.skipTransition();
  });
  ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(type => {
    window.addEventListener(type, () => transition?.skipTransition(), { passive: true, capture: true });
  });
})();

